<template>
  <div>
    <PaginatedTable
      ref="table"
      table="workorders"
      :table-class="Workorder"
      :filter-definitions="filterDefinitions"
      :headers="headers"
    >
      <template #right-actions>
        <v-btn
          aria-label="Import Workorders"
          color="secondary"
          class="mr-2"
          flat
          @click="importer.open()"
        >
          <v-icon>mdi-upload</v-icon>Import
        </v-btn>
      </template>

      <template #item.actions="{ item }">
        <v-btn
          aria-label="View Workorder"
          view="View"
          icon="mdi-eye"
          flat
          density="compact"
          @click="dialog?.open(item.id)"
        />
      </template>
    </PaginatedTable>
    <WorkorderImport ref="importer" @imported="table?.getData()" />
    <WorkorderDialog ref="dialog" @change="table?.getData()" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Workorder } from "@/classes";
import WorkorderDialog from "@/components/workorder/WorkorderDialog.vue";
import PaginatedTable from "@/components/base/tables/PaginatedTable.vue";
import { FilterDefinition } from "@/types/filter";
import { DataTableHeader } from "@/types/table";
import WorkorderImport from "@/components/workorder/WorkorderImport.vue";

const headers: DataTableHeader[] = [
  {
    title: "Order",
    key: "order",
    sortable: true,
  },
  {
    title: "Func. Loc.",
    key: "functional_location",
    sortable: true,
  },
  {
    title: "Maintenance Item",
    key: "maintenance_item",
    sortable: true,
  },
  {
    title: "Maintenance Plan",
    key: "maintenance_plan",
    sortable: true,
  },
  {
    title: "Action",
    key: "actions",
    sortable: false,
  },
];

const filterDefinitions: FilterDefinition[] = [
  {
    label: "Order",
    value: "order",
    type: "string",
  },
  {
    label: "Func. Loc.",
    value: "functional_location",
    type: "string",
  },
  {
    label: "Maintenance Item",
    value: "maintenance_item",
    type: "string",
  },
  {
    label: "Maintenance Plan",
    value: "maintenance_plan",
    type: "string",
  },
];

const table = ref<InstanceType<typeof PaginatedTable> | null>(null);
const dialog = ref<InstanceType<typeof WorkorderDialog> | null>(null);
const importer = ref<InstanceType<typeof WorkorderImport> | null>(null);
</script>
